import React from 'react';
import { renderComponent } from '../helpers/RenderComponent';

function RenderedComponent({ value }) {
  return renderComponent(value);
}

export default React.memo(RenderedComponent);
